/* eslint-disable react/no-unescaped-entities */
/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React, { useContext } from 'react';
import { connect, useSelector } from 'react-redux';
import { Switch, Route, withRouter, Redirect, Link } from 'react-router-dom';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { Acl } from 'modules/common/components/Acl';
import { getJson } from 'session';
import { ModalContext } from 'App';
import { GET_FORMDATA_ORDINANCE_REVISION_RPT } from 'modules/real-property-tax/components/constant';
import LandApplicationContainer from '../land-application/container/LandApplicationContainer';
import LandSettingsRoutes from '../settings/container/LandSettingsRoutes';
import LandOwnerContainer from '../land-owner/container/LandOwnerContainer';
import LandImportCSV from '../import-csv/containers/LandImportCsvContainer';
import TransactionModal from '../land-application/modals/TransactionModal';
import OrdinanceRevisionDropdown from '../../components/OrdinanceRevisionDropdown';

function LandContainer({ match, pathName }) {
  const permissions = getJson('permissions');
  const setModal = useContext(ModalContext);
  
  const dropDownFormData = useSelector(
    ({ api }) => _.get(api, `${GET_FORMDATA_ORDINANCE_REVISION_RPT}.item`) || {}
  );
  
  localStorage.getItem('defaultFormValue');

  const ordinanceRevisionId =
    parseInt(_.get(dropDownFormData, 'year.value'), 10) ||
    JSON.parse(localStorage.getItem('defaultFormValue'))?.year?.value;

  const handleTransactionModal = (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <TransactionModal />,
      title: 'Transaction',
      modalSize: 'modal-lg',
    });
  };

  return (
    <React.Fragment>
      <div className="card-content-listing">
        <div className="container-fluid">
          <div className="row">
            <ul className="nav nav-tabs btn-settings-tab-container">
              {Acl(permissions, ['E2E RPT LAND APPLICATION']) && (
                <li className="nav-item">
                  <Link
                    to="/rpt/land/applications"
                    className={`nav-link btn-settings-tab border-right py-3 px-5 ${
                      pathName.indexOf('rpt/land/applications') > -1
                        ? 'selected'
                        : ''
                    }`}
                  >
                    Applications
                  </Link>
                </li>
              )}
              {Acl(permissions, ['E2E RPT LAND OWNER']) && (
                <li className="nav-item">
                  <Link
                    to="/rpt/land/land-owner"
                    className={`nav-link btn-settings-tab border-right py-3 px-5 ${
                      pathName.indexOf('rpt/land/land-owner') > -1
                        ? 'selected'
                        : ''
                    }`}
                  >
                    Owner
                  </Link>
                </li>
              )}
              {Acl(permissions, ['E2E RPT LAND SETTINGS']) && (
                <li className="nav-item">
                  <Link
                    to="/rpt/land/land-settings"
                    className={`nav-link btn-settings-tab border-right py-3 px-5 ${
                      pathName.indexOf('rpt/land/land-settings') > -1
                        ? 'selected'
                        : ''
                    }`}
                  >
                    Settings
                  </Link>
                </li>
              )}
              {Acl(permissions, ['E2E RPT LAND IMPORT CSV']) && (
                <li className="nav-item">
                  <Link
                    to="/rpt/land/import-csv"
                    className={`nav-link btn-settings-tab border-right py-3 px-5 ${
                      pathName.indexOf('rpt/land/import-csv') > -1
                        ? 'selected'
                        : ''
                    }`}
                  >
                    Import CSV
                  </Link>
                </li>
              )}
            </ul>
            {
              <div className="d-flex ml-auto">
                <div
                  className="d-flex justify-content-end align-items-center mr-5"
                  style={{ flexGrow: '2' }}
                >
                  <OrdinanceRevisionDropdown pathName={pathName} />
                </div>
              </div>
            }
            {Acl(permissions, ['E2E RPT LAND APPLICATION TRANSACTION']) &&
              pathName.indexOf('rpt/land/applications/') > -1 && (
                <div className="ml-auto mr-5 align-self-center">
                  <button
                    type="button"
                    onClick={handleTransactionModal}
                    className="btn btn-primary cms-bg-color-primary cms-outline-primary  font-weight-bold px-4 ml-auto"
                  >
                    Transaction
                  </button>
                </div>
              )}
          </div>
        </div>
        <Switch>
          {Acl(permissions, ['E2E RPT LAND APPLICATION']) && (
            <Route
              exact
              path={`${match.path}`}
              render={() => <Redirect to={`${match.path}/applications`} />}
            />
          )}
          {Acl(permissions, ['E2E RPT LAND APPLICATION']) && (
            <Route
              path={`${match.path}/applications`}
              render={() => (
                <LandApplicationContainer
                  ordinanceRevisionId={+ordinanceRevisionId}
                />
              )}
            />
          )}
          {Acl(permissions, ['E2E RPT LAND OWNER']) && (
            <Route
              path={`${match.path}/land-owner`}
              component={LandOwnerContainer}
            />
          )}
          {Acl(permissions, ['E2E RPT LAND SETTINGS']) && (
            <Route
              path={`${match.path}/land-settings`}
              render={() => (
                <LandSettingsRoutes
                  ordinanceRevisionId={+ordinanceRevisionId}
                />
              )}
            />
          )}
          {Acl(permissions, ['E2E RPT LAND IMPORT CSV']) && (
            <Route
              path={`${match.path}/import-csv`}
              render={() => (
                <LandImportCSV
                  ordinanceRevisionId={+ordinanceRevisionId}
                />
              )}
            />
          )}
        </Switch>
      </div>
    </React.Fragment>
  );
}

LandContainer.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
  pathName: PropTypes.string.isRequired,
};

const mapStateToProps = ({ api }, { match, location }) => ({
  mainModule: _.get(match, 'params.mainModule'),
  pathName: _.get(location, 'pathname'),
  profile: _.get(api, 'AUTH/user_profile.item') || {},
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps)]);

export default enhance(LandContainer);
